<template>
  <div>
    <b-nav tabs>
        <b-nav-item v-for="item in data.meetingRooms" :key="data.meetingRooms.id" 
            :active="item.id == selectedMeetingRoomId" @click="selectedMeetingRoomId = item.id">{{ item.name }}</b-nav-item>
    </b-nav>
    <br>
    <b-row>
        <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <b-button variant="outline-info" @click="changeDate(new Date(refDate.getTime() - 604800000))">Semana Anterior</b-button>
            &nbsp;
            <b-button variant="outline-info" @click="changeDate(new Date())">Hoje</b-button>
            &nbsp;
            <b-button variant="outline-info" @click="changeDate(new Date(refDate.getTime() + 604800000))">Próxima Semana</b-button>
            &nbsp;
            <span class="ml-2">{{ $utils.dateStringFormat(startDate) }} ~  {{ $utils.dateStringFormat(endDate) }}</span>
                   
        </b-col>
        <b-col>
            <b-form-datepicker
                v-model="calendarDate"
                class="ml-auto"
                size="sm"
                :date-format="'yyyy-MM-dd'"
                :value="refDate"
                @input="onCalendarChange"
                style="max-width: 160px;"
            ></b-form-datepicker>
        </b-col>
    </b-row>
    <p></p>

    <div
      class="d-flex justify-content-between agenda-scroll"
      style="max-width: 100vw; max-height: 80vh; overflow: auto;"
    >
      <agenda-date-component
        v-for="item in items"
        :item="item"
        :key="item.id"
        class="flex-shrink-0"
        style="min-width: 250px;"
      ></agenda-date-component>
    </div>

    <b-modal v-model="showCalendar" title="Escolha uma data" hide-footer>
      <b-form-datepicker
        v-model="calendarDate"
        :date-format="'yyyy-MM-dd'"
        @input="onCalendarChange"
      ></b-form-datepicker>
    </b-modal>

  </div>
</template>
<script>
import AgendaDateComponent from '../components/AgendaDateComponent.vue';

import Vue from 'vue'
import axios from "axios";
import { BFormDatepicker, BModal } from 'bootstrap-vue';

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
    name: 'AgendaComponent',
    components: {
        AgendaDateComponent,
        BFormDatepicker,
        BModal
    },
    data: function() {
        return {
            refDate: new Date(),
            startDate: "",
            endDate: "",
            showCalendar: false,
            calendarDate: null,

            selectedMeetingRoomId: 1,

            data: {
                meetingRooms: [
                    {
                        id: 1,
                        name: "Sala Nelson"
                    },
                    {
                        id: 2,
                        name: "Sala Clara"
                    }
                ],
                items: [
                    { id: 1, meetingRoomId: 2, title: '16 Jun', date:"2025-06-16", weekday: "Seg", meetings: [
                        { id: 1, st: 1, startTime: "08:00", endTime: "09:00", name: "Alexandre", description: "Reunião", variant: "list-group-item-accent-danger" },
                        { id: 2, st: 0, startTime: "10:00", endTime: "11:00", name: "Antônio José", description: "Reunião de Teste" },
                        { id: 3, st: 1, startTime: "16:00", endTime: "17:00", name: "Ronaldo", description: "Reunião de Alinhamento" }
                    ] },
                    { id: 2, meetingRoomId: 1, title: '17 Jun', date:"2025-06-17", weekday: "Ter", meetings: [
                        { id: 4, st: 1, startTime: "13:00", endTime: "14:00", name: "Alexandre", description: "Reunião" },
                        { id: 5, st: 1, startTime: "10:00", endTime: "11:00", name: "Antônio José", description: "Reunião de Teste" }                
                    ] },
                    { id: 3, meetingRoomId: 1, title: '18 Jun', date:"2025-06-18", weekday: "Qua", meetings: [
                        { id: 7, st: 1, startTime: "08:00", endTime: "09:00", name: "Alexandre", description: "Reunião" },
                        { id: 8, st: 1, startTime: "10:00", endTime: "11:00", name: "Antônio José", description: "Reunião de Teste", variant: "list-group-item-accent-warning" },
                        { id: 9, st: 0, startTime: "16:00", endTime: "17:00", name: "Ronaldo", description: "Reunião de Alinhamento" },
                        { id: 10, st: 1, startTime: "16:00", endTime: "17:00", name: "Ronaldo", description: "Reunião de Alinhamento" },
                        { id: 11, st: 1, startTime: "16:00", endTime: "17:00", name: "Ronaldo", description: "Reunião de Alinhamento" }

                    ] },                  
                    { id: 5, meetingRoomId: 1, title: '17 Jun', date:"2025-06-20", weekday: "Sex", meetings: [
                        { id: 4, st: 1, startTime: "13:00", endTime: "14:00", name: "Alexandre", description: "Reunião" },
                        { id: 5, st: 1, startTime: "10:00", endTime: "11:00", name: "Antônio José", description: "Reunião de Teste" }
                    ] },
                    { id: 7, meetingRoomId: 1, title: '25 Jun', date:"2025-06-25", weekday: "Qua", meetings: [
                        { id: 4, st: 1, startTime: "13:00", endTime: "14:00", name: "Alexandre", description: "Reunião" },
                        { id: 5, st: 1, startTime: "10:00", endTime: "11:00", name: "Antônio José", description: "Reunião de Teste" }                
                    ] },
                    { id: 6, meetingRoomId: 2, title: '17 Jun', date:"2025-06-20", weekday: "Sex", meetings: [
                        { id: 4, st: 1, startTime: "13:00", endTime: "14:00", name: "Alexandre", description: "Reunião" },
                        { id: 5, st: 1, startTime: "10:00", endTime: "11:00", name: "Antônio José", description: "Reunião de Teste" }                
                    ] }
                ]
            },
            items: []
        }
    },
    watch: {       
    },
    methods: {
        fillWeekItems() {
            //console.log("Meeting room: ", this.selectedMeetingRoomId);
            // Helper to format date as yyyy-MM-dd
            const pad = n => n.toString().padStart(2, '0');
            const format = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            // Helper to get weekday name in Portuguese
            const weekdays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

            // Parse start and end dates
            const start = new Date(this.startDate);
            start.setHours(start.getHours() + 6);
            const end = new Date(this.endDate);
            end.setHours(end.getHours() + 6);

            // Filter items for the selected meeting room
            const roomItems = this.data.items.filter(
                item => item.meetingRoomId === this.selectedMeetingRoomId
            );

            // Build the week items array
            const weekItems = [];
            for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                const dateStr = format(d);
                // Try to find an item for this date
                let found = roomItems.find(item => item.date === dateStr);
                if (found) {
                    weekItems.push(found);
                } else {
                    // If not found, create a blank item for this date
                    weekItems.push({
                        id: dateStr,
                        meetingRoomId: this.selectedMeetingRoomId,
                        title: '', // or you can format as you wish
                        date: dateStr,
                        weekday: weekdays[d.getDay()],
                        meetings: []
                    });
                }
            }
            this.items = weekItems;
        },
        changeDate(newRefDate) {
            if (this.refDate && (this.refDate instanceof Date)) {
                this.refDate = newRefDate
            }
            const ref = this.refDate;            
            const prevSunday = new Date(ref);
            prevSunday.setDate(ref.getDate() - ref.getDay());
            
            const nextSaturday = new Date(ref);
            nextSaturday.setDate(ref.getDate() + (6 - ref.getDay()));
            
            const pad = n => n.toString().padStart(2, '0');
            const format = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            this.startDate = format(prevSunday);
            this.endDate = format(nextSaturday);
            this.calendarDate = this.formatDateForPicker(this.refDate);

            // Check if the current date is within the range of startDate and endDate
            if (
                this.data &&
                this.data.startDate &&
                this.data.endDate &&
                (
                    this.refDate < new Date(this.data.startDate) ||
                    this.refDate > new Date(this.data.endDate)
                )
            ) {
                this.refreshData();
            }
        },
        onCalendarChange(dateString) {
        // dateString is in 'yyyy-MM-dd'
        if (dateString) {
            const d = new Date(dateString + 'T00:00:00');
            this.changeDate(d);
            this.showCalendar = false;
        }
        },
        formatDateForPicker(dateObj) {
        const pad = n => n.toString().padStart(2, '0');
        return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())}`;
        }
    },
    watch: {
        selectedMeetingRoomId: 'fillWeekItems',
        startDate: 'fillWeekItems',
        endDate: 'fillWeekItems',
    },
    mounted() {        
        this.changeDate(new Date());
        this.calendarDate = this.formatDateForPicker(this.refDate);
        this.fillWeekItems();
    }
}
</script>


<style scoped>
.agenda-scroll {
  overflow-x: auto;
  overflow-y: auto;
  max-width: 100vw;
  max-height: 80vh;
  /* Optional: add padding or background as needed */
}
</style>